module.exports = __webpack_public_path__ + "img/nodata_inprogress.e7ac4039.png";